if (__DEV__) {
  require('./components/AutomateStudioOverviewContainer');
}

import AutomateEngineDetailsContainer from './components/AutomateEngineDetailsContainer';
import createEngineWizard from './pages/create-engine-wizard';
import dashboards from 'plugins/engines/pages/engine-dashboards';
import builds from 'plugins/engines/pages/engine-builds';
import configEngineWizard from './pages/config-engine-wizard';
import tasks from 'plugins/engines/pages/engine-tasks';
import logs from 'plugins/engines/pages/engine-logs';

console.log('In AutomateStudio ', logs);
const passthrough = props => props.children;

export default store => ({
  path: 'automate-studio',

  component: passthrough,

  indexRoute: {
    onEnter: (nextState, replace) => replace('/automate-studio/overview')
  },

  childRoutes: [
    {
      path: 'overview',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "engines" */ './components/AutomateStudioOverviewContainer')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },

      childRoutes: [
        // wizard is a child of overview because the wizard opens in a modal
        // over the top of overview
        createEngineWizard
      ].map(r => r(store))
    },
    {
      path: ':engineId',
      resource: 'engine',
      indexRoute: {
        onEnter: ({ location }, replace) => {
          replace(`${location.pathname}/builds`);
        }
      },

      component: AutomateEngineDetailsContainer,

      childRoutes: [dashboards, builds, tasks, logs].map(r => r(store))
    },
    {
      path: ':engineId/config',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "engines" */ './components/AutomateEngineDetailsContainer')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },
      childRoutes: [configEngineWizard].map(r => r(store))
    },
    {
      path: 'flows/templates',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "engines" */ './components/FlowsTemplatesPage')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },

      childRoutes: [
        // wizard is a child of overview because the wizard opens in a modal
        // over the top of overview
        // createEngineWizard
      ].map(r => r(store))
    },
    {
      path: 'flows/templates/:flowId',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "engines" */ './components/CreateNewFlow/AutomateCreateNewFlow')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },

      childRoutes: [
        // wizard is a child of overview because the wizard opens in a modal
        // over the top of overview
        // createEngineWizard
      ].map(r => r(store))
    },
    {
      path: 'flows/new',
      resource: 'engine',
      getComponent(nextState, cb) {
        import(/* webpackChunkName: "engines" */ './components/CreateNewFlow')
          .then(component => {
            return cb(null, component.default);
          })
          .catch(errorLoading);
      },

      childRoutes: [
        // wizard is a child of overview because the wizard opens in a modal
        // over the top of overview
        // createEngineWizard
      ].map(r => r(store))
    }
  ]
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}



// WEBPACK FOOTER //
// ./src/client/plugins/automate-studio/index.js